<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-content>
        <v-form
                ref="queryForm">
            <v-row
                    justify="center"
                    align="center">
                <!--<v-col-->
                <!--cols="1"-->
                <!--xs="4">-->
                <!--<z-source-selector :search="false" label="状态" v-model="queryRequest.state"-->
                <!--param="STATE"></z-source-selector>-->
                <!--</v-col>-->
                <!--<v-col-->
                <!--cols="2"-->
                <!--xs="4">-->
                <!--<z-source-selector label="公司"-->
                <!--v-model="queryRequest.companyId"-->
                <!--source="CompanySelector"></z-source-selector>-->
                <!--</v-col>-->
                <v-col
                        cols="2"
                        xs="4">
                    <v-text-field
                            clearable
                            v-model="queryRequest.acctName"
                            label="用户名"
                            single-line
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="2"
                        xs="4">
                    <v-text-field
                            clearable
                            v-model="queryRequest.cellPhone"
                            label="手机号"
                            single-line
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="4">
                    <v-btn

                            :loading="loading"
                            @click="handleQuery">
                        搜索
                        <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                            class="ma-2"
                            @click="resetQuery">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-col>

            </v-row>
        </v-form>
        <v-row justify="center">
            <v-col cols="10">
                <v-data-table
                        :headers="headers"
                        :items="list"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        :search="search"
                >
                    <template v-slot:top>
                        <v-toolbar height="40" flat>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="600px">
                                <template v-slot:activator="{ on }">
                                    <v-btn small v-on="on">添加
                                        <v-icon small>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">医院同步模式添加</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-form v-if="hospAddStep == 0 ">
                                                <v-row align="center">
                                                    <v-col cols="6">
                                                        <v-text-field v-model="hospUserRequest.acctNo"
                                                                      label="手机号/账号"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-btn :disabled="!hospUserRequest.acctNo"
                                                               :loading="hospUserRequestLoading" @click="hospUserQuery">
                                                            查询医院用户
                                                            <v-icon right>mdi-magnify</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                            <v-form ref="hospUserAddForm"
                                                    v-model="hospUserAddFormValid"
                                                    v-else-if="hospAddStep == 1 ">
                                                <v-row align="center">
                                                    <!--<v-col cols="6">-->
                                                        <!--<v-text-field disabled v-model="hospUerInfo.compName"-->
                                                                      <!--label="医院用户所属公司"></v-text-field>-->
                                                    <!--</v-col>-->

                                                    <v-col cols="6">

                                                        <z-source-selector
                                                                           :itemsList="hospUerInfo.hospInfoList"
                                                                           label="选择机构"
                                                                           :initLoad="false"
                                                                            item-text="hospName"
                                                                            item-value="id"
                                                                           v-model="newItem.institutionId"
                                                                           :rules="[v => !!v || '机构为必选项']"
                                                                           required>
                                                        </z-source-selector>

                                                    </v-col>
                                                    <v-col cols="6">
                                                        <z-source-selector label="角色"
                                                                           v-model="newItem.roleId"
                                                                           :rules="[v => !!v || '角色为必选项']"
                                                                           source="RoleSelector">
                                                        </z-source-selector>
                                                    </v-col>
                                                </v-row>

                                                <v-row align="center">
                                                    <v-col cols="6">
                                                        <v-text-field disabled v-model="newItem.cellPhone"
                                                                      label="手机号/账号"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-text-field disabled v-model="newItem.acctName"
                                                                      label="用户名"></v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <!--<v-row>-->
                                                <!--<v-text-field v-model="newItem.remark" label="备注"></v-text-field>-->
                                                <!--</v-row>-->
                                            </v-form>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!--<v-btn color="blue darken-1" text @click="hospAddStep=0">关闭</v-btn>-->
                                        <v-btn color="darken-1"
                                               text
                                               v-if="hospAddStep==1"
                                               @click="hospAddStep=0">上一步</v-btn>
                                        <v-btn color="blue darken-1"
                                               :loading="newItemCommitLoading"
                                               :disabled="!hospUserAddFormValid"
                                               text
                                               v-if="hospAddStep==1"
                                               @click="addCommit">提交
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <!--<v-icon-->
                        <!--small-->
                        <!--class="mr-4"-->
                        <!--@click="editItem(item)"-->
                        <!--&gt;-->
                        <!--mdi-pencil-->
                        <!--</v-icon>-->
                        <v-icon
                                small
                                @click="handleDelete(item)"
                        >
                            mdi-delete
                        </v-icon>

                    </template>


                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog
                v-model="deleteDialog"
                width="500"
        >
            <v-card>
                <v-card-title>
                    <span>请确认是否删除用户:{{deleteItem.acctName}}</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="deleteDialog = false">取消</v-btn>
                    <v-btn
                            color="error"
                            text
                            @click="deleteCommit"
                    >
                        删除
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
                top
                v-model="snackbar"
        >
            {{ snackbarText }}

        </v-snackbar>
    </v-content>
</template>

<script>
  import {queryRequest, hospModelAdminAcctAdd, deleteAcct, hospUserInfoQuery} from '@/api/acct'

  export default {
    name: "UserManagement",
    data() {
      return {
        snackbar: false,
        snackbarText: '',
        hospAddStep: 0,  //0 查询手机用户 ,1 回显用户，选择公司后提交
        dialog: false,
        updateDialog: false,
        search: '',
        total: 0,
        list: [],
        loading: false,
        options: {},
        headers: [
          {text: '用户名', value: 'acctName', sortable: false},
          {text: '手机号', value: 'cellPhone', sortable: false},
          {text: '机构', value: 'institution', sortable: false},
          // {text: '状态', value: 'stateDesc', sortable: false},
          // {text: '所属公司', value: 'companyName'},
          // {text: '角色', value: 'roleName', sortable: false},
          {text: '创建时间', value: 'createDateTime'},
          {text: '操作', value: 'actions', sortable: false},

        ],
        hospUserRequest: {
          acctNo: ''
        },
        hospUserRequestLoading: false,
        queryRequest: {
          id: '',
          state: '',
          acctType: '',
          cellPhone: '',
          acctName: '',
          remark: '',
          companyId: '',
          createDateTime: [],
          updateDateTime: '',
          sortInfo: {
            sortBy: [],
            sortDesc: []
          },
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          }
        },
        newItem: {
          cellPhone: '',
          acctName: '',
          // companyId: '',
          roleId: '',
          hospAcctId: '',
          institutionId: ''
        },
        hospUserAddFormValid: false,
        newItemCommitLoading: false,
        hospUerInfo: {
          cellPhone: '',
          acctName: '',
          remark: '',
          compName: '',
          id: '',
          hospNameList: []
        },
        editedItem: {},
        deleteDialog: false,
        deleteItem: {
          acctName: ''
        }
      }
    },
    watch: {
      options: {
        handler(val) {
          console.log(val)
          this.queryRequest.pagedQueryInfo.index = val.page
          this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
          this.queryRequest.sortInfo.sortBy = val.sortBy
          this.queryRequest.sortInfo.sortDesc = val.sortDesc
          this.handleQuery()
        }
      }
    },
    methods: {
      handleQuery() {
        this.loading = true
        queryRequest(this.queryRequest).then(res => {
          this.list = res.list
          this.total = res.total
          this.loading = false
        }).catch(err => {
          this.loading = false
        })
      },
      resetQuery() {
        this.$refs.queryForm.reset()
      },
      editItem() {

      },
      handleDelete(item) {
        this.deleteItem = item
        this.deleteDialog = true
      },
      hospUserQuery() {
        this.hospUserRequestLoading = true
        hospUserInfoQuery(this.hospUserRequest).then(res => {
          if (res.noUser) {
            this.snackbarText = "无此用户"
            this.snackbar = true
          } else {
            this.hospUerInfo = res
            this.newItem = res
            this.newItem.hospAcctId = this.hospUerInfo.id
            this.hospAddStep = 1
          }
          this.hospUserRequestLoading = false
        }).catch(err => {
          this.hospUserRequestLoading = false
        })
      },
      addCommit() {
        if (this.hospUserAddFormValid) {
          this.newItemCommitLoading = true
          var reqData={};
          reqData.institutionId=this.newItem.institutionId;
          reqData.cellPhone=this.newItem.cellPhone;
          reqData.roleId=this.newItem.roleId;
          hospModelAdminAcctAdd(reqData).then(res => {
            this.newItemCommitLoading = false
            this.dialog = false;
            this.hospAddStep = 0;
            this.handleQuery();
            Object.assign(this.newItem, this.$options.data().newItem)
            Object.assign(this.hospUerInfo, this.$options.data().hospUerInfo)
          }).catch(err => {
            this.newItemCommitLoading = false
          })
        }

      },
      deleteCommit() {
        deleteAcct(this.deleteItem.id).then(res => {
          this.deleteDialog = false
          this.snackbarText = "删除成功"
          this.snackbar = true
          this.handleQuery()
        }).catch(err => console.error(err))
      }
    }
  }
</script>

<style scoped>

</style>